// Screen-to-screen motion (user call 2026-09-07: "premium and smooth"):
// a route change wrapped in the View Transitions API, so the old screen
// dissolves while the new one rises — a whole-screen cross-fade only (a
// shared-element morph of the pressed control into the question title
// was tried and removed the same day: "cheap and lagging"; index.css,
// "screen transitions"). `flushSync` commits the router update inside the
// transition's callback, which is what lets the browser snapshot the new
// screen. Where the API is missing (Firefox), or the
// reader prefers reduced motion, the update simply runs and the page's own
// `.page-in` entrance plays alone. While a transition is live the root
// carries `.vt` — a hook for CSS that must know (nothing uses it yet; the
// page entrance deliberately keeps playing inside the new snapshot).
import { flushSync } from "react-dom";

const VT_CLASS = "vt";

const reducedMotion = () =>
  typeof window !== "undefined" &&
  Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches);

export function withViewTransition(update) {
  const doc = typeof document !== "undefined" ? document : null;
  if (
    !doc ||
    typeof doc.startViewTransition !== "function" ||
    reducedMotion()
  ) {
    update();
    return;
  }
  const root = doc.documentElement;
  root.classList.add(VT_CLASS);
  const transition = doc.startViewTransition(() => {
    flushSync(update);
  });
  const done = () => root.classList.remove(VT_CLASS);
  // `finished` settles either way (a skipped transition rejects `ready`,
  // never `finished`); guard anyway so a class never sticks
  Promise.resolve(transition?.finished).then(done, done);
}
